import React, {useEffect, useState} from 'react'
import {useDroppable} from "@dnd-kit/core";
import {AllActivityTypes, AllActivityTypesArray} from "../../../../types-enums/activity";
import './styles.css'
import {Icon, Text} from "atmosfair-ui";
import clsx from "clsx";
import CreateJourneyFromTravelComponentsCardGroup
    from "../card-list/create-journey-from-travel-components-card-group/CreateJourneyFromTravelComponentsCardGroup";
import {orderBy} from "lodash";
import {
    CreateJourneyFromTravelComponentsDayCardPropsContext,
    CreateJourneyFromTravelComponentsDayCardPropsContextProps
} from "../../common";
import {theme} from "../../../../styles/theme";

export interface AllActivitiesProps {
    droppableZoneId: string,
    activities: AllActivityTypesArray
    onArrowDown: (activity: AllActivityTypes) => void,
    onDelete: (activity: AllActivityTypes) => void
    isOver: boolean,
    isRecalculatingActivityEmissions: boolean,
    hasExactDates: boolean,
    journeyDurationInDays: number,
}

const AllActivitiesCard = ({
                               droppableZoneId,
                               activities,
                               onDelete,
                               onArrowDown,
                               isOver,
                               isRecalculatingActivityEmissions,
                               hasExactDates,
                               journeyDurationInDays,
                           }: AllActivitiesProps) => {
    const [createJourneyFromTravelComponentsDayCardContext, setCreateJourneyFromTravelComponentsDayCardContext] =
        useState<CreateJourneyFromTravelComponentsDayCardPropsContextProps>({
            droppableZoneId,
            allActivities: activities,
            activitiesAtDay: orderBy(activities, activity => activity.common.activityType, ['desc']),
            onActivityDelete: onDelete,
            onActivityArrowDown: onArrowDown,
            isRecalculatingActivityEmissions,
            hasExactDates,
            journeyDurationInDays,
        })
    const {setNodeRef} = useDroppable({id: droppableZoneId, disabled: isRecalculatingActivityEmissions})

    useEffect(() => {
        setCreateJourneyFromTravelComponentsDayCardContext({
            ...createJourneyFromTravelComponentsDayCardContext,
            droppableZoneId,
            activitiesAtDay: orderBy(activities, activity => activity.common.activityType, ['desc']),
            onActivityDelete: onDelete,
            onActivityArrowDown: onArrowDown,
            isRecalculatingActivityEmissions,
            hasExactDates,
            journeyDurationInDays

        })
    }, [
        droppableZoneId,
        activities,
        onDelete,
        onArrowDown,
        isRecalculatingActivityEmissions,
        hasExactDates,
        journeyDurationInDays
    ]);

    return <CreateJourneyFromTravelComponentsDayCardPropsContext.Provider
        value={createJourneyFromTravelComponentsDayCardContext}>
        <div
            style={{backgroundColor: theme.colors.white}}
            className={clsx('all-activities-card-container', 'create-journey-from-travel-components-box', isOver && 'all-activities-card-is-over-container')}>
            <Text
                classes={'all-activities-card-headline'}
                variant={'headlineMedium'}>SCREENS.JOURNEY.INITIAL_GROUP_TITLE</Text>
            {isOver && <div className={"all-activities-card-is-over-overlay"}>
                <Icon containerClasses={'all-activities-delete-icon-wiggle'} icon={"trash"} size={'large'}
                      color={"warning"}/>
            </div>}
            <ul ref={setNodeRef} className={'all-activities-card-unordered-list-wrapper'}>
                <CreateJourneyFromTravelComponentsCardGroup isInitialGroup={true}/>
            </ul>
        </div>
    </CreateJourneyFromTravelComponentsDayCardPropsContext.Provider>
}

export default AllActivitiesCard